import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import ApplyPage from "./pages/ApplyPage.tsx";
import ThankYouPage from "./pages/ThankYouPage.tsx";
import FbAdsPage from "./pages/FbAdsPage.tsx";
import FbAdsV2Page from "./pages/FbAdsV2Page.tsx";
import GcAdsPage from "./pages/GcAdsPage.tsx";
import GetGrowthScorePage from "./pages/GetGrowthScorePage.tsx";
import GetGrowthScoreThankYouPage from "./pages/GetGrowthScoreThankYouPage.tsx";
import NotFound from "./pages/NotFound.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GetGrowthScorePage />} />
          <Route path="/GetGrowthScore" element={<GetGrowthScorePage />} />
          <Route path="/GetGrowthScore/thank-you" element={<GetGrowthScoreThankYouPage />} />
          <Route path="/thank-you" element={<GetGrowthScoreThankYouPage />} />
          <Route path="/home" element={<Index />} />
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/apply/thank-you" element={<ThankYouPage />} />
          <Route path="/fb-ads" element={<FbAdsPage />} />
          <Route path="/fb-ads-v2" element={<FbAdsV2Page />} />
          <Route path="/gc-ads" element={<GcAdsPage />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
